import { IframeSection } from '@/types';

interface IframeRendererProps {
  section: IframeSection;
}

export function IframeRenderer({ section }: IframeRendererProps) {
  const { url, height = '500px' } = section.data;

  return (
    <div className="p-6 bg-card border border-border rounded-lg">
      <iframe
        src={url}
        style={{ height, width: '100%' }}
        className="rounded-md"
        sandbox="allow-scripts allow-same-origin"
        title="Embedded content"
      />
    </div>
  );
}
